<script setup lang="ts">
import { RouterView } from 'vue-router'

import DialogsHost from '@/components/DialogsHost.vue'
</script>

<template>
  <RouterView />
  <DialogsHost />
</template>
